import { render, staticRenderFns } from "./about.vue?vue&type=template&id=37726a88&scoped=true&"
import script from "./about.ts?vue&type=script&lang=ts&"
export * from "./about.ts?vue&type=script&lang=ts&"
import style0 from "./about.styl?vue&type=style&index=0&id=37726a88&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37726a88",
  null
  
)

export default component.exports